module.exports = __webpack_public_path__ + "img/408.fc9f5d9a.png";